// © 2013 - 2024 Tinder, Inc., ALL RIGHTS RESERVED

import React, { memo } from 'react';
import { IconProps as Props } from '../types';

const SvgSticker: React.FC<Props> = (allProps) => {
  const { fill, primary, secondary, tertiary, quaternary, ...props } = allProps;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      focusable="false"
      aria-hidden="true"
      role="presentation"
      {...props}
    >
      <g fill={primary ?? fill ?? 'currentColor'}>
        <path d="M.27 5.363a.445.445 0 0 1 0-.818l.042-.018c1.597-.68 2.837-2 3.42-3.638l.033-.094a.443.443 0 0 1 .835 0l.033.094a6.214 6.214 0 0 0 3.42 3.638l.041.018c.36.153.36.665 0 .818l-.041.018c-1.597.68-2.838 2-3.42 3.638l-.033.094a.443.443 0 0 1-.835 0l-.033-.094a6.214 6.214 0 0 0-3.42-3.638z" />
        <path d="M21.818 14.434c.547-.548.179-1.465-.592-1.409-2.418.178-4.27.898-5.521 2.153-1.252 1.256-1.97 3.113-2.147 5.54-.056.772.858 1.141 1.404.593z" />
        <path d="M1.08 12.085c0-1.21.186-2.378.53-3.475.384.494.694 1.046.914 1.641.57 1.542 2.746 1.542 3.316 0a6.255 6.255 0 0 1 3.491-3.599c1.504-.614 1.504-2.782 0-3.396a6.269 6.269 0 0 1-2.098-1.41A11.46 11.46 0 0 1 12.621.51c5.693 0 10.422 4.136 11.367 9.575.093.538-.36.993-.903.977-3.869-.111-6.806.812-8.74 2.753-1.83 1.836-2.754 4.57-2.754 8.146 0 .205.003.412.01.622.016.545-.438.998-.974.905-5.423-.948-9.546-5.692-9.546-11.403" />
      </g>
    </svg>
  );
};

const Memo = memo(SvgSticker);
export default Memo;
